import * as React from 'react';
import {Card, CardBody, Col, Container, Row} from 'reactstrap';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import './visicooler-nuevo.scss';
import VisicoolerNuevoTable from './visicooler-nuevo-table';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {FuerzasVenta, IFuerzaVenta} from '../../../../utils/constants';


interface VisicoolerNuevoState {
    keyword: string;
    response?: mirana.BuscarVisicoolersResponse;
    fuerzaVenta?: IFuerzaVenta;
}

class VisicoolerNuevo extends React.Component<RouteComponentProps<any>, VisicoolerNuevoState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props) {
        super(props);
        this.state = {
            keyword: ''
        };
    }

    public componentWillReceiveProps(newProps) {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === newProps.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta, response: undefined, keyword: ''});
    }

    public componentDidMount() {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === this.props.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta});
    }

    private cancelarBusquedaOnClick = () => {
        this.setState({keyword: '', response: undefined})
    };

    private buscarClientesOnEnter = (e) => {
        const {keyword} = this.state;
        if (e.key === 'Enter' && keyword && keyword.length >= 3) {
            this.buscarClientes();
        }
    };

    private buscarClientesOnClick = () => {
        const {keyword} = this.state;
        if (keyword && keyword.length >= 3) {
            this.buscarClientes();
        }
    };

    private buscarClientesPaginado = (page: number) => {
        this.buscarClientes(page);
    };

    private actualizarData = (data: mirana.BuscarVisicoolersResponse) => {
        this.setState({response: data});
    };

    private buscarClientes = async (page?: number) => {
        const {keyword, fuerzaVenta} = this.state;
        const response = await this.apiClient.filtrarClientesSinVisicooler(fuerzaVenta ? fuerzaVenta.id : '', keyword, page);
        this.setState({response});
    };

    private handleKeywordChange = (e) => {
        this.setState({keyword: e.target.value})
    };

    private get cancelarButton() {
        if (this.state.keyword !== '') {
            return <button className='form__form-group-button'
                           onClick={this.cancelarBusquedaOnClick}>
                <CloseCircleIcon/>
            </button>
        }
        return null;
    };

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>{this.state.fuerzaVenta ? this.state.fuerzaVenta.descripcion : ''}:
                            Asignar Visicooler</h3>
                    </Col>
                    <Col md={12} lg={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={4} lg={4}>
                                        <div className='form'>
                                            <div className='form__form-group'>
                                                <div className='form__form-group-field'>
                                                    <input name='search' type='text'
                                                           autoComplete='off'
                                                           placeholder='Buscar por código de cliente o razón social'
                                                           value={this.state.keyword}
                                                           onChange={this.handleKeywordChange}
                                                           onKeyPress={this.buscarClientesOnEnter}/>
                                                    {this.cancelarButton}
                                                    <button className={`form__form-group-button`}
                                                            onClick={this.buscarClientesOnClick}><MagnifyIcon/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} lg={12}>
                                        <VisicoolerNuevoTable
                                            fuerzaVentaId={this.state.fuerzaVenta ? this.state.fuerzaVenta.id : ''}
                                            data={this.state.response} keyword={this.state.keyword}
                                            handlePagination={this.buscarClientesPaginado}
                                            actualizarData={this.actualizarData}/>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(VisicoolerNuevo);



// WEBPACK FOOTER //
// ./src/components/pages/visicooler/nuevo/visicooler-nuevo.tsx